import React from 'react'
import { AppLinearProgress } from '@components'
import { Box, Typography } from '@mui/material'
import { globalExecutionsTableReportCellData } from 'Pages/Admin/GlobalExecution/@signals'
import { LoadingText } from 'Pages/Main/Home/@components'
import { reportSearchesModalId } from '@signals'

export default function progressBarColumn() {
	return [{
		name: 'id_last_execution', label: 'Status',
		options: {
			display: 'excluded',
		},
	}, {
		name: 'id_last_execution',
		label: 'Status',
		options: {
			filter: false,
			customBodyRowRenderLite: (idReport, row) => <ProgressBar idReport={idReport} row={row}/>,
		},
	}]
}

function ProgressBar({ idReport, row }) {
	const rowData = { ...row, ...globalExecutionsTableReportCellData.value[idReport] }
	return <Box
		sx={{
			cursor: !rowData?.generating ? 'pointer' : '',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: 1,
		}}
		onClick={() => {
			if (!rowData?.generating) {
				reportSearchesModalId.value = idReport
			}
		}}>
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 1, mb: 0.5 }}>
			<LoadingText label={!rowData?.generating ? 'Running' : 'Generating'}/>
			{!rowData?.generating && <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
				{rowData?.completeTasksString || 0}/{rowData?.totalTasksString || 0}
			</Typography>}
		</Box>
		<Box sx={{ width: 1 }}>
			<AppLinearProgress actual={rowData?.percentage} total={100} generating={rowData?.generating}/>
		</Box>
		<Box sx={{ width: 1 }}>
			<Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
				{!rowData?.generating && 'Click progress bar to view details'}
			</Typography>
		</Box>
	</Box>
}
